import { h, Fragment } from 'preact';
import Visibility from '../visibility';
import CustomHeight from '../height/custom-height';
import { useSignal, useSignalEffect } from '@preact/signals';
import { useEffect } from 'preact/hooks';
import * as files from '../../assets/files.json';

type ReviewTableRowType = string[];

type ReviewTablePropsType = {
  headers: string[];
  body: ReviewTableRowType[];
  isLoaded: any;
};

const ReviewTable = (props: ReviewTablePropsType) => {
  return (
    <>
      <Visibility condition={props.isLoaded.value}>
        <table class="table table-responsive table-hover">
          <thead>
            <tr>
              {props.headers.map((item, index) => {
                return <th key={index}>{item}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {props.body.map((row, index) => {
              return (
                <tr key={index}>
                  {row.map((item: any, index) => {
                    if (item && item.constructor.name == 'Array') {
                      return (
                        <td key={index}>
                          <ul>
                            {item.map((ans, index) => {
                              return <li key={index}>{ans}</li>;
                            })}
                          </ul>
                        </td>
                      );
                    } else if (item && item.constructor.name == 'Object') {
                      if (item.image) {
                        const fileSrc = item.value.value;
                        if (fileSrc) {
                          return (
                            <td key={index}>
                              <img
                                class="preview-container"
                                alt="preview"
                                src={item.value}
                                onError={e => {
                                  const target =
                                    e.target as unknown as HTMLImageElement;

                                  target.style.width = '40px';
                                  target.src = files.pdf;
                                  console.log('error loading');
                                  if (!target['hasEvent']) {
                                    target.addEventListener('click', e => {
                                      const a = document.createElement('a');
                                      a.href = fileSrc;
                                      // console.log(62, a.href);
                                      a.target = '_blank';
                                      // a.download = 'preview';
                                      a.click();
                                    });

                                    target['hasEvent'] = true;
                                  }
                                }}
                              />
                            </td>
                          );
                        }
                      }
                      return <td key={index} />;
                    }
                    return <td key={index}>{item}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </Visibility>

      <Visibility condition={!props.isLoaded.value}>
        <div>
          <div class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <CustomHeight height="30vh" />
        </div>
      </Visibility>
    </>
  );
};

export default ReviewTable;
